import type { AppProps } from "next/app";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "@/theme";
import { Session, SessionContextProvider } from "@supabase/auth-helpers-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserSupabaseClient } from "@/lib/supabaseClient";

import "../styles/index.css";
import "../styles/prism.css";

import { useState } from "react";
import { ProModeProvider } from "@/lib/context/ProModeContext";
import { LoadingProvider } from "@/lib/context/LoadingContext";
import PrototypeNotification from "@/components/PrototypeNotification";

export default function App({
  Component,
  pageProps,
}: AppProps<{
  initialSession: Session;
}>) {
  const [supabaseClient] = useState(() => createBrowserSupabaseClient());
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <SessionContextProvider
        supabaseClient={supabaseClient}
        initialSession={pageProps.initialSession}>
        <ChakraProvider theme={theme}>
          <ProModeProvider>
            <LoadingProvider>
              <Component {...pageProps} />
              <PrototypeNotification />
            </LoadingProvider>
          </ProModeProvider>
        </ChakraProvider>
      </SessionContextProvider>
    </QueryClientProvider>
  );
}
